import React from "react";
import { Link } from "react-router-dom";
import { Camera } from "lucide-react";
import { useI18n } from "@/context/I18nContext";

export function Footer() {
  const { t } = useI18n();
  return (
    <footer className="mt-24 border-t border-slate-200 bg-slate-900 text-slate-300">
      <div className="mx-auto max-w-7xl px-6 py-16">
        <div className="grid grid-cols-2 gap-10 md:grid-cols-4 lg:grid-cols-5">
          <div className="col-span-2 lg:col-span-2">
            <div className="flex items-center gap-2">
              <div className="flex h-9 w-9 items-center justify-center rounded-lg bg-white">
                <Camera size={18} className="text-slate-900" />
              </div>
              <span className="font-display text-xl font-extrabold text-white">
                Lumina<span className="text-blue-500">Stock</span>
              </span>
            </div>
            <p className="mt-4 max-w-xs text-sm text-slate-400">{t("footer.tagline")}</p>
          </div>
          <div>
            <h4 className="font-mono text-xs uppercase tracking-widest text-slate-500">{t("footer.explore")}</h4>
            <ul className="mt-4 space-y-2.5 text-sm">
              <li><Link to="/browse" className="hover:text-white transition">{t("nav.browse")}</Link></li>
              <li><Link to="/browse?type=photo" className="hover:text-white transition">{t("nav.photos")}</Link></li>
              <li><Link to="/browse?type=graphic" className="hover:text-white transition">{t("nav.graphics")}</Link></li>
            </ul>
          </div>
          <div>
            <h4 className="font-mono text-xs uppercase tracking-widest text-slate-500">{t("footer.company")}</h4>
            <ul className="mt-4 space-y-2.5 text-sm">
              <li><span className="hover:text-white transition cursor-pointer">{t("footer.about")}</span></li>
              <li><span className="hover:text-white transition cursor-pointer">{t("footer.careers")}</span></li>
              <li><span className="hover:text-white transition cursor-pointer">{t("footer.contact")}</span></li>
            </ul>
          </div>
          <div>
            <h4 className="font-mono text-xs uppercase tracking-widest text-slate-500">{t("footer.legal")}</h4>
            <ul className="mt-4 space-y-2.5 text-sm">
              <li><span className="hover:text-white transition cursor-pointer">{t("footer.terms")}</span></li>
              <li><span className="hover:text-white transition cursor-pointer">{t("footer.privacy")}</span></li>
              <li><span className="hover:text-white transition cursor-pointer">{t("footer.license")}</span></li>
            </ul>
          </div>
        </div>
        <div className="mt-12 border-t border-slate-800 pt-6 text-sm text-slate-500">
          © {new Date().getFullYear()} PT Kromatika Media Indonesia · LuminaStock. {t("footer.rights")}
        </div>
      </div>
    </footer>
  );
}
